import { ClaimSubmissionRequest, ClaimUpdateRequest, ViewClaimDetailsResponse } from 'all-in-one-shared-api';
import { DEFAULT_DATE_FORMAT } from 'utils';
import { getFilename } from 'utils/getFilename';
import { getLocaleDescription } from 'utils/getLocaleDescription';
import { ClaimFormState } from '../../../newClaim/schema';
import moment from 'moment';

export const formatClaimSubmissionRequest = (claimId: string, request?: ClaimSubmissionRequest): ClaimUpdateRequest => {
  const res = {
    ...(request || {}),
    referenceNo: claimId,
    patientMemberType: request?.patientMemberType || '',
    claimType: request?.claimType || '',
    fullClaim: !!request?.fullClaim,
    firstClaim: !!request?.firstClaim,
    firstClaimWithGenerali: !!request?.firstClaimWithGenerali,
    diagnosisCode: request?.diagnosisCode || '',
    treatmentDate: request?.treatmentDate ? moment(request.treatmentDate).format('DD/MM/YYYY') : '',
    receiptAmounts: request?.receiptAmounts || [],
  };

  // somehow the treatmentDate can be either js date or format 'DD/MM/YYYY'
  if (request?.treatmentDate.length == 10) {
    res.treatmentDate = request?.treatmentDate;
  } else {
    res.treatmentDate = request?.treatmentDate ? moment(request.treatmentDate).format('DD/MM/YYYY') : '';
  }
  return res;
};
// eslint-disable-next-line
const buildUploadFileList = (filePaths?: string[]): any[] => {
  if (!filePaths) return [];
  return filePaths.map((filePath: string) => ({
    uid: filePath,
    name: getFilename(filePath),
  }));
};

export const toClaimFormState = (data: ViewClaimDetailsResponse, isEnglish: boolean): ClaimFormState => {
  return {
    currency: data?.receiptAmounts?.length && data?.receiptAmounts?.length > 0 ? data.receiptAmounts[0].currency : '',
    doctorName: getLocaleDescription(isEnglish)(data.doctor),
    doctorId: data.doctor.code,
    diagnosisCode: data.diagnosis.code,
    receiptAmounts: data.receiptAmounts?.map((receiptAmount) => receiptAmount.amount) || [],
    claimType: data.claimType.code,
    claimTypeObject:
      data.claimType.code === 'OP' ? data.benefits.map((benefit) => `__${benefit.code}`) : [data.claimType.code || ''],
    ctcRequest: data.ctcRequest,
    editAllowed: data.editAllowed,
    treatmentDate: moment(data.treatmentDate).format(DEFAULT_DATE_FORMAT),
    receipts: buildUploadFileList(data.receiptFiles),
    referralLetters: buildUploadFileList(data.refLetters),
    otherDocuments: buildUploadFileList(data.otherDocs),
    prevClaimSettlements: buildUploadFileList(data.prevClaimFiles),
    partialClaim: !data.fullClaim,
    isFirstClaim: data.firstClaim,
    firstClaimWithGenerali: data.firstClaimWithGenerali,
    anotherMemberId: data.anotherMemberId,
    anotherPolicyNumber: data.anotherPolicyNumber,
    otherInsurerName: data.otherInsurerName,
    firstClaimAmount: data.otherClaimAmount?.amount,
    firstClaimCurrency: data.otherClaimAmount?.currency,
    patientMemberType: data.patientMemberType,
    referenceNo: data.referenceNo,
  };
};
